<template>
    <v-card elevation="0" 
        @dragover.prevent="handleDragOver($event)" 
        @dragleave.prevent="handleDragLeave($event)" 
        @drop.prevent="handleFileDrop($event)"
        @dragend.prevent="handleDragLeave($event)"
    >
        <v-card-title class="px-4 py-2">
            Activity
            <v-btn icon @click="loadCommunications">
                <v-icon small>fas fa-sync-alt</v-icon>
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        
        <v-card-text 
            :style="`height:calc(100vh - 353px - ${app.bottom_height}px);overflow:auto; scrollbar-color: red yellow;`" 
            id="messages" 
            class="mb-2 pa-0"
            v-scroll.self="onScroll"
        >
            <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
            <div class="pa-2">
                <messages 
                    :messages="messages" 
                    :phone_number="phone_number"
                    @getMoreMessages="getMoreMessages"
                ></messages>
            </div>

            <!-- BM: IMAGE MESSAGE DIALOG -->
            <v-dialog v-model="show_file_upload" max-width="500">
                <v-card>
                    <v-card-title class="text-h5 primary">
                        Send Images
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="files = []; show_file_upload = false;"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="py-4"
                        @dragover.prevent="handleDragOver($event)" 
                        @dragleave.prevent="handleDragLeave($event)" 
                        @drop.prevent="handleFileDrop($event)"
                        @dragend.prevent="handleDragLeave($event)"
                    >
                        <div v-if="files.length > 0">
                            <span v-for="(file, index) in files" :key="index">
                                <v-hover v-slot="{ hover }">
                                    <span>
                                        <v-img 
                                            v-if="isImage(file)"
                                            :src="previewSrc(file)"
                                            :aspect-ratio="1"
                                            alt="preview image" 
                                            class="ma-1 rounded upload-preview-image white float-left"
                                        >
                                            <v-overlay
                                                :absolute="true"
                                                :value="hover"
                                                opacity="0.8"
                                            >
                                                <v-btn x-small icon outlined @click="removeImage(index)"><v-icon>mdi-close</v-icon></v-btn>
                                            </v-overlay>
                                        </v-img>
                                        <v-responsive
                                            v-else
                                            :aspect-ratio="1"
                                            alt="preview pdf"
                                            class="ma-1 primary rounded upload-preview-image float-left"
                                        >
                                            <v-row align="center" justify="center" style="height:100%">
                                                <v-col class="text-center">
                                                    <v-icon v-if="file.type.indexOf('pdf') > 0" x-large class="mt-6">mdi-file-pdf-box</v-icon>
                                                    <v-icon v-if="file.type.indexOf('audio') > -1" x-large class="mt-6">mdi-volume-high</v-icon>
                                                    <v-icon v-else x-large class="mt-6">mdi-file</v-icon>
                                                    <v-overlay
                                                        :absolute="true"
                                                        :value="hover"
                                                        opacity="0.8"
                                                    >
                                                        <v-btn x-small icon outlined @click="removeImage(index)"><v-icon>mdi-close</v-icon></v-btn>
                                                    </v-overlay>
                                                </v-col>
                                            </v-row>
                                                
                                            <!-- </v-card> -->
                                        </v-responsive>
                                    </span>
                                </v-hover>
                            </span>
                        </div>
                        <v-row v-else style="min-height:145px;" class="text-center" align="center" justify="center">
                            <v-col>
                                Drop Files Here or <a @click="openFiles">click here</a> to select
                            </v-col>
                        </v-row>
                        <!-- FILE DROP OVERLAY -->
                        <v-overlay 
                            :absolute="true"
                            :value="highlight_file_drop"
                            color="success"
                        >
                            DROP FILES HERE
                        </v-overlay>
                        <div style="clear:both;"></div>
                    </v-card-text>
                    <v-card-actions>
                        <!-- <div style="height:20px;">
                            <v-progress-linear v-show="uploading_files" :value="upload_progress"></v-progress-linear>
                        </div> -->

                        <v-textarea
                            v-model="message_text"
                            hide-details="auto"
                            outlined
                            :label="app.phone_number_input && app.phone_number_input.length >= 10 ? `Message to `+ app.phoneNumberFormat(app.phone_number_input) : ''"
                            append-icon="fas fa-paper-plane"
                            @click:append="sendMessageWithImages"
                            @keydown="imageMessageKeydown"
                            rows="1"
                            auto-grow
                            messages="Shift+Enter for a new line. ENTER to send."
                            :loading="uploading_files"
                            class="mt-4"
                        >
                            <template v-slot:prepend>
                                <v-btn @click="openFiles" icon>
                                    <v-icon>mdi-paperclip</v-icon>
                                </v-btn>
                            </template>
                        </v-textarea>

                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- sending message loader -->
            <!-- <v-container v-if="sending_message" class="text-right" fluid> -->
                <!-- <v-progress-circular indeterminate :size="20" :width="3"></v-progress-circular> -->
            <!-- </v-container> -->

        </v-card-text>
        <v-card-actions>
            <v-textarea
                v-model="message_text"
                hide-details="auto"
                outlined
                :label="app.phone_number_input && app.phone_number_input.length >= 10 ? `Message to `+ app.phoneNumberFormat(app.phone_number_input) : ''"
                append-icon="fas fa-paper-plane"
                @click:append="sendMessage"
                @keydown="messageKeydown"
                rows="1"
                auto-grow
                messages="Shift+Enter for a new line. ENTER to send."
                :loading="sending_message"
            >
                <template v-slot:prepend>
                    <v-btn @click="show_file_upload = true" icon>
                        <v-icon>mdi-paperclip</v-icon>
                    </v-btn>
                </template>
            </v-textarea>
        </v-card-actions>

        <!-- FILE DROP OVERLAY -->
        <v-overlay 
            :absolute="true"
            :value="highlight_file_drop"
            color="success"
        >
            DROP FILES HERE
        </v-overlay>

        <div style="display:none;">
            <input type="file" name="" id='input_file' hidden @change="handleSelectedFiles" multiple :accept="accepted_file_types.join(',')">
            <button onclick="open_file()"></button>
        </div>
    </v-card>
</template>

<script>
import { useAppStore } from '../stores/app'
import { useUserStore } from '../stores/user'
// import Pusher from 'pusher-js'
// import AudioPlayer from './AudioPlayer.vue'
import axios from 'axios'
import Messages from './Messages.vue'

export default {
    name: 'Communications',
    props: ['phone_number'],
    data: () => ({
        message_text: "",
        messages: [],
        media_urls: [],
        loading: false,
        sending_message: false,
        app: null,
        user: null,
        highlight_file_drop: null,
        drag_over_timeout: null,
        files: [],
        upload_progress: 0,
        uploading_files: false,
        message_files: [],
        show_file_upload: false,
        accepted_file_types: ['image/jpeg', 'image/png', 'video/mp4', 'audio/mp3', 'image/gif', 'application/pdf', 'text/vcard', 'text/x-vcard', 'text/calendar', 'text/csv'],
        limit: 100,
        offset: 0,
        loading_more: false,
        first_load_complete: false,
        before: null,
        bookmark: null,
        messages_loaded: false
    }),
    created: function() {
        this.app = useAppStore()
        this.user = useUserStore()
    },
    mounted: function() {
        this.loadCommunications()
        // this.subscribe()
    },
    computed: {},
    methods: {
        getMoreMessages: function() {
            let before = this.messages[Object.keys(this.messages)[0]]?.date
            if(before != this.before) {
                this.before = before
                console.log("getMoreMessages", this.before)
                this.loading_more = true
                this.loadCommunications()
            }

            // if(this.first_load_complete && !this.loading && !this.loading_more) {
            //     this.loading_more = true
            //     this.loadCommunications()
            // }
        },
        isImage: function(file) {
            return file.type.indexOf('image') == 0
        },
        handleSelectedFiles: function(e) {
            console.log(e.target.files)
            if (e.target.files && e.target.files[0]) {
                this.files.push(...e.target.files)
            }
        },
        openFiles: function() {
            document.getElementById('input_file').click();
        },
        removeImage: function(index) {
            console.log("del:", index)
            // delete(this.files[index])
            this.files.splice(index, 1)
        },
        previewSrc: function(file) {
            return URL.createObjectURL(file)
        },
        handleDragOver: function(e) {
            // this.highlight_file_drop = "green lighten-3"
            this.highlight_file_drop = true
            this.drag_over_timeout = null
        },
        handleDragLeave: function(e) {
            // event fires on child elements too, so only turn off if leaving the overlay, otherwise we get a flicker effect
            if(e.fromElement.className.indexOf('overlay') == -1)
                this.highlight_file_drop = false
        },
        handleFileDrop: function(e) {
            console.log("file drop", e.dataTransfer.files)
            this.highlight_file_drop = false
            // this.files = e.dataTransfer.files
            e.dataTransfer.files.forEach(file => {
                if(this.accepted_file_types.includes(file.type) || file.type.indexOf("audio/") > -1 || file.type.indexOf("image/") > -1)
                    this.files.push(file)
            });
            if(this.files.length > 0)
                this.show_file_upload = true
            this.scrollToBottom()
        },
        loadCommunications: function() {
            let g = this
            this.loading = true

            let before = this.messages[Object.keys(this.messages)[0]]?.date
            this.bookmark = Object.keys(this.messages)[0]
            // let before = null
            // for(const key in this.messages)
            //     console.log("MD:", before, this.messages[key].date)

            this.app.req.get(`lead/communications/${this.phone_number}?limit=${this.limit}&before=${before}`)
            .then(data => {
                if(!this.first_load_complete){
                    this.scrollToBottom()
                    this.first_load_complete = true
                }
                if(Object.keys(data).length > 0)
                    this.messages = {...data, ...this.messages}
                this.loading = false

                //set timeout to clear the unread message 
                g.app.req.delete(`lists/unread_messages/${this.$route.params.contact_id}`)
                .then(() => {
                    setTimeout(function() {
                        g.app.getUnreadMessages()
                    }, 3000)
                })

                if(!this.loading_more)
                    this.scrollToBottom()
                else
                    this.scrollToBookmark()

                this.loading_more = false
                this.messages_loaded = true
            })
        },
        messageKeydown: function(e) {
            if(e.key == "Enter" && !e.shiftKey) {
                e.preventDefault()
                this.sendMessage()
            }
        },
        imageMessageKeydown: function(e) {
            if(e.key == "Enter" && !e.shiftKey) {
                e.preventDefault()
                this.sendMessageWithImages()
            }
        },
        onScroll: function(e) {
            if(e.target.scrollTop == 0) {
                console.log("getMoreMessages", e.target.scrollTop)
                this.getMoreMessages()
            }
        },
        scrollToBottom: function() {
            setTimeout(function() {
                var messagesDiv = document.getElementById("messages");
                messagesDiv.scrollTop = messagesDiv.scrollHeight;
            }, 100)
        },
        scrollToBookmark: function() {
            // document.getElementById("messages_container").scrollIntoView();
            var g = this
            setTimeout(function() {
                var bookmarkDiv = document.getElementById(g.bookmark);
                bookmarkDiv.scrollIntoView()
                setTimeout(function() {
                    var messagesDiv = document.getElementById("messages");
                    messagesDiv.scrollTop -= 75
                }, 1)
            }, 1)
        },
        sendMessageWithImages: function() {
            this.uploading_files = true
            let formData = new FormData();          
            this.files.forEach((file) => {
                formData.append(file.name, file)
            })

            let url = this.app.api.url + "lead/communications/upload_files"

            let headers = {
                'X-WP-Nonce': this.app.api.restNonce,
            }

            var g = this
            axios.post(url, formData, {
                headers,
                onUploadProgress: function(progressEvent) {
                    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    g.upload_progress = percentCompleted
                    console.log(percentCompleted)
                }
            }).then(data => {
                console.log(data)
                g.uploading_files = false
                g.message_files = data.data
                g.files = []
                g.show_file_upload = false
                g.sendMessage()
            }).catch(error => g.uploading_files = false)
        },
        
        sendMessage: function() {
            if(this.message_text.length == 0 && this.message_files.length == 0)
                return

            this.loading = true
            this.sending_message = true
            this.scrollToBottom()

            let g = this

            //get the last twilio number that this contact interacted with and see if it matches
            //the current phone number selection
            //add a switch


            this.app.req.post('lead/communications/send_sms', {
                from: this.user.current_phone_number.phone_number, 
                phone_number: this.app.phone_number_input, 
                message: this.message_text,
                files: this.fileUrls()
            })
            .then(data => {
                let g = this
                g.message_files = []
                g.show_file_upload = false
                // this.messages[data.sid] = data
                this.$set(this.messages, data.sid, data)
                g.loading = false
                g.sending_message = false
            })
            this.message_text = ""
        },
        fileUrls: function() {
            return this.message_files.map(file => {
                let url = file.post_content;
                url = url.replace("dialer-now.test", "dialer-now.wyatt.agency")
                return url
            })
        },
    },
    watch: {
        phone_number: function(newV, oldV) {
            if(newV[0] != oldV[0]) {
                this.messages = []
                this.loadCommunications()
            }
        },
    },
    components: {
        // AudioPlayer,
        Messages
    }
}
</script>

<style scoped>
.upload-preview-image {
    width:31%;
}
</style>
